import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import RecuperaPraticaCard from "common/components/recupera-pratica-card";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { Col, Row } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

const title = "1. Iniziamo";
const subtitle = "Crea il tuo profilo in pochi minuti.";

const FirstStepPage: React.FC = () => {
	const location = useLocation();

	const isDesktop = window.innerWidth >= 768;

	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Header />
					<Topbar />

					<div className="container-fluid body-section-no-header px-0">
						<section>
							<Row>
								<Col sm={12} lg={8}>
									<div>
										<h2 className="mb-3 ms-3">{title}</h2>
										<span className="gray">{subtitle}</span>
									</div>

									<Outlet />
								</Col>

								{isDesktop &&
									location?.pathname === AppRouterService.get(PathEnum?.creazioneProfilo) && (
										<RecuperaPraticaCard />
									)}

								{/* CHE SIGNIFICA? */}
								{/* {currentSubStep?.id === SubStepsEnum.CODICE_ATTIVAZIONE && null}  */}

								{isDesktop &&
									location?.pathname === AppRouterService.get(PathEnum?.cercaImpresa) && (
										<Col sm={12} md={4}>
											<DettaglioPianoCard />
										</Col>
									)}
							</Row>
						</section>
					</div>
				</div>

				<Footer />
			</div>
		</>
	);
};
export default FirstStepPage;
